"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeBox1_4 = exports.HomeBox1_3 = exports.HomeBox1_2 = exports.HomeBox1_1 = void 0;
var react_1 = __importDefault(require("react"));
var tab2_1 = require("../../tab2");
require("./index.less");
var zxg_1 = require("../../zxg");
var small_1 = require("../../../../quotetable/small");
var zixun_1 = require("../../zixun");
/** 自选股 个股聚焦 个股公告 */
function HomeBox1_1() {
    return (react_1.default.createElement("div", { className: "homebox1" },
        react_1.default.createElement(tab2_1.Tab2, { boxdata: [
                {
                    tab_html: react_1.default.createElement("a", { href: "https://quote.eastmoney.com/zixuan/?from=center" }, "\u81EA\u9009\u80A1"),
                    more: react_1.default.createElement("a", { href: "https://quote.eastmoney.com/zixuan/?from=center" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "homebox1_b" },
                        react_1.default.createElement(zxg_1.ZXGBox1Table, null))
                },
                {
                    tab_html: react_1.default.createElement("a", { href: "https://finance.eastmoney.com/" }, "\u4E2A\u80A1\u805A\u7126"),
                    more: react_1.default.createElement("a", { href: "https://finance.eastmoney.com/" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "homebox1_b" },
                        react_1.default.createElement(zixun_1.ZXGNewsList, { type: "news" }))
                },
                {
                    tab_html: react_1.default.createElement("a", { href: "https://data.eastmoney.com/notices/" }, "\u4E2A\u80A1\u516C\u544A"),
                    more: react_1.default.createElement("a", { href: "https://data.eastmoney.com/notices/" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "homebox1_b" },
                        react_1.default.createElement(zixun_1.ZXGNewsList, { type: "notice" }))
                }
            ] })));
}
exports.HomeBox1_1 = HomeBox1_1;
function HomeBox1_2() {
    return (react_1.default.createElement("div", { className: "homebox1" },
        react_1.default.createElement(tab2_1.Tab2, { boxdata: [
                {
                    tab_html: react_1.default.createElement("a", { href: "gridlist.html#industry_board" }, "\u884C\u4E1A\u677F\u5757"),
                    more: react_1.default.createElement("a", { href: "gridlist.html#industry_board" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "homebox1_b" },
                        react_1.default.createElement(small_1.QuoteSmallTable, { fs: 'm:90+s:4+f:!50',
                            table_key: 'BoardsCPDesc',
                            count: 5,
                            order: 'f3',
                            orderdur: 1 }))
                },
                {
                    tab_html: react_1.default.createElement("a", { href: "gridlist.html#concept_board" }, "\u6982\u5FF5\u677F\u5757"),
                    more: react_1.default.createElement("a", { href: "gridlist.html#concept_board" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "homebox1_b" },
                        react_1.default.createElement(small_1.QuoteSmallTable, { fs: 'm:90+t:3+f:!50',
                            table_key: 'BoardsCPDesc',
                            count: 5,
                            order: 'f3',
                            orderdur: 1 }))
                },
                {
                    tab_html: react_1.default.createElement("a", { href: "gridlist.html#region_board" }, "\u5730\u57DF\u677F\u5757"),
                    more: react_1.default.createElement("a", { href: "gridlist.html#region_board" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "homebox1_b" },
                        react_1.default.createElement(small_1.QuoteSmallTable, { fs: 'm:90+t:1+f:!50',
                            table_key: 'BoardsCPDesc',
                            count: 5,
                            order: 'f3',
                            orderdur: 1 }))
                }
            ] })));
}
exports.HomeBox1_2 = HomeBox1_2;
function HomeBox1_3() {
    return (react_1.default.createElement("div", { className: "homebox1" },
        react_1.default.createElement(tab2_1.Tab2, { boxdata: [
                {
                    tab_html: react_1.default.createElement("a", { href: "https://data.eastmoney.com/zjlx/dpzjlx.html" }, "\u4E2A\u80A1\u8D44\u91D1\u6D41\u5165"),
                    more: react_1.default.createElement("a", { href: "https://data.eastmoney.com/zjlx/dpzjlx.html" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "homebox1_b" },
                        react_1.default.createElement(small_1.QuoteSmallTable, { fs: 'm:0+t:6,m:0+t:80,m:1+t:2',
                            table_key: 'MainCaptialFlow',
                            count: 5,
                            order: 'f62',
                            orderdur: 1 }))
                }
            ] })));
}
exports.HomeBox1_3 = HomeBox1_3;
function HomeBox1_4() {
    return (react_1.default.createElement("div", { className: "homebox1" },
        react_1.default.createElement(tab2_1.Tab2, { boxdata: [
                {
                    tab_html: react_1.default.createElement("a", { href: "https://data.eastmoney.com/zjlx/dpzjlx.html" }, "\u4E2A\u80A1\u8D44\u91D1\u6D41\u51FA"),
                    more: react_1.default.createElement("a", { href: "https://data.eastmoney.com/zjlx/dpzjlx.html" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "homebox1_b" },
                        react_1.default.createElement(small_1.QuoteSmallTable, { fs: 'm:0+t:6,m:0+t:80,m:1+t:2',
                            table_key: 'MainCaptialFlow',
                            count: 5,
                            order: 'f62',
                            orderdur: 0 }))
                }
            ] })));
}
exports.HomeBox1_4 = HomeBox1_4;
